import React from "react";
import Card from "../../components/Card";
import { useUser } from "../../context";
import settings from "../../i11/Settings";
import Policy from "./Policy";
import Privacy from "./Privacy";

const PrivacyPolicy = () => {
	const { locale } = useUser();

	return (
		<Card title={settings[locale].privacy_terms} classTitle="title-green">
			<Privacy />
			<br />
			<Policy />
		</Card>
	);
};

export default PrivacyPolicy;
